import {
    SET_SEARCHED_LAYER,
    SET_ADDITIONAL_LAYERS_DROPDOWN,
    SET_SCROLLING_TO_SEARCHED_LAYER
} from './Types';
import {ISearchPanelAction, ISearchPanelReducerState} from "./searchPanelTypes"

const defaultState = {
    selectedLayer: {
        category: '',
        systemName: ''
    },
    additionalLayersDropdown: false,
    scrollingToSelectedLayer: false
};

const reducer = (state:ISearchPanelReducerState = defaultState, action:ISearchPanelAction) => {
    switch (action.type) {
        case SET_SEARCHED_LAYER:
            return {
                ...state,
                selectedLayer: {
                    category: action.category,
                    systemName: action.systemName
                },
                scrollingToSelectedLayer: true
            };
        case SET_SCROLLING_TO_SEARCHED_LAYER:
            return {
                ...state,
                scrollingToSelectedLayer: action.value
            };
        case SET_ADDITIONAL_LAYERS_DROPDOWN:
            return {
                ...state,
                additionalLayersDropdown: action.value
            };
        default:
            return state;
    }
};

export default reducer;